module.exports = __webpack_public_path__ + "img/系统监控.5dc571ca.svg";